import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to import your suppliers. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: '5knIFL',
    description: 'Supplier Import help content text',
  },
  uploadFile: {
    id: '8cjYM6',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the import process',
  },
});
